<template>
  <v-container>
    <material-card
      :title="Item.title"
      :text="Item.subTitle"
      color="green"> 
      <v-form
      ref="form"
      v-model="valid"
      lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex v-for="(iField,index) in Field" :key="index" :class="[iField.width]">
              <v-text-field
              :type="iField.type"
                :label="iField.label"
                :name="iField.formName"
                class="green-input"
                :disabled="!iField.isEnable"
                 v-model="modelList[iField.name]"
                 :rules="iField.nameRules"
                 />
                 
            </v-flex>


            <v-flex md12>
              <b>Correct Answer</b>
              <v-radio-group v-model="modelList.correct_answer" row :rules="correctAnsRule">
                <v-radio label="Option 1" value="1"></v-radio>
                <v-radio label="Option 2" value="2"></v-radio>
                <v-radio label="Option 3" value="3"></v-radio>
                <v-radio label="Option 4" value="4"></v-radio>
              </v-radio-group>
            </v-flex>


            <v-flex md6>
              <v-text-field type="number" v-model="modelList.prize_amount" placeholder="Price amount"></v-text-field>
            </v-flex>

            <v-flex md6>
              <v-text-field type="date" v-model="modelList.contest_date"></v-text-field>
            </v-flex>
            <v-flex
              xs12
              text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success" @click="onClickButton">{{ Item.submitText }}</v-btn>
              <v-btn
                class="mx-2 font-weight-light"
                color="info" @click="closeModal">Close</v-btn>
                
            </v-flex> 
          </v-layout>
        </v-container>

  

      </v-form>
    </material-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Datepicker from 'vuejs-datepicker';
export default {  
  
  components: {
    Datepicker
  },
  props: {
    // title: String,
    Item: Object,
    Field: Array,
    Value: Object
  },
  watch: {
    dialog() {
        this.$refs.form.reset()
    }
  },
  data () {
      return {
      overlay: false,
      correct_answer: null,
      date: null,
      valid: true,
      modelList: {},
      correctAnsRule: [
        v => !!v || 'Please select a correct answer'
        
      ],
      }
  },
  watch: {
      overlay (val) {
        val && setTimeout(() => {
          this.overlay = false
        }, 3000)
      },
  },
  created () {
    this.modelList = this.Value
  },
  methods: {
    ...mapActions("dailyQuiz", ["storeContestQuiz"]),
    async onClickButton (event) {
      if (this.$refs.form.validate()) {
        this.overlay = true
        const response = await this.storeContestQuiz(this.modelList) 
        if (response.status === "OK") {
          this.$refs.form.reset()
          this.modelList = {}
          this.$emit('emitted', response)
        } 
      } else {
        console.log('Second')
      }
    },
    closeModal () {
      this.$refs.form.reset()
      this.$emit('closed')
    }
  }
}
</script>
